import { StateSelectionWidget } from "components/FormWidget";

const uiSchema = () => ({
  state_id: {
    "ui:widget": StateSelectionWidget,
  },
  details: {
    "ui:widget": "textarea",
  },
});

export default uiSchema;
